<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="h-6 w-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"
    />
  </svg>
</template>

<script>
export default {
  name: 'LayerPlus',
  props: {
    customStyle: {
      type: String,
      default: 'h-6 w-6',
    },
  },
}
</script>
